import Vue from 'vue'
import AudioCtrl from '@js/audio-ctrl'
import { TP as AudioTP, getSoundEffectUrl } from '@js/config/audio/common'

function clickHandler () {
  AudioCtrl.play({ url: getSoundEffectUrl(AudioTP.BUTTON) })
}

function mouseupHandler (e) {
  e.target.blur()
}

Vue.directive('clickSoundButton', {
  bind: function (el, binding, vnode) {
    if (binding.value === false) {
      return
    }
    vnode.elm.addEventListener('click', clickHandler)
    vnode.elm.addEventListener('mouseup', mouseupHandler)
  },

  update: function (el, binding, vnode) {
    if (binding.oldValue === true && binding.value === false) {
      // 启用 -> 禁用
      vnode.elm.removeEventListener('click', clickHandler)
      vnode.elm.removeEventListener('mouseup', mouseupHandler)
    }
    if (binding.oldValue === false && binding.value === true) {
      vnode.elm.removeEventListener('click', clickHandler)
      vnode.elm.removeEventListener('mouseup', mouseupHandler)
      vnode.elm.addEventListener('click', clickHandler)
      vnode.elm.addEventListener('mouseup', mouseupHandler)
    }
  },

  unbind: function (el, binding, vnode) {
    vnode.elm.removeEventListener('click', clickHandler)
    vnode.elm.removeEventListener('mouseup', mouseupHandler)
  }
})
